/**
 * Make model conflictable
 */
import { SEATRADIUS } from '@/constants';
import SVG from 'svg.js';
import Application from '../application';

export interface ConflictableRequirements {
  attributes: Record<string, any>;
  view: SVG.G;
  app: Application;
  shape: SVG.Shape;
}

export const ConflictableMixin = <T extends { new (...args: any[]): ConflictableRequirements }>(base: T) => {
  return class ConflictableMixin extends base {
    isConflicted = false;
    prevStrokeColor: string | null = null;
    conflictShape: SVG.Circle | null = null;

    get conflicted() {
      return this.isConflicted;
    }

    set conflicted(conflicted) {
      if (conflicted && this.app.isShowConflicts()) {
        //this.markAsConflicted();
        this.initConflictShape();
      } else {
        //this.unmarkAsConflicted();
        this.removeConflictShape();
      }
      this.isConflicted = conflicted;
    }

    initConflictShape([cx, cy] = this.attributes.position) {
      if (!this.conflictShape || !this.conflictShape.node) {
        const size = SEATRADIUS * 2.4 * this.app.seatmap.scale;
        this.conflictShape = this.view.circle(size).center(cx, cy).addClass('conflict-shape').fill('none');
      }
    }

    removeConflictShape() {
      this.conflictShape && this.conflictShape.remove();
      this.conflictShape = null;
    }

    markAsConflicted() {
      this.prevStrokeColor = this.shape.style('stroke') as unknown as string;
      this.shape.style('stroke', '#aa0000');
    }

    unmarkAsConflicted() {
      this.shape.style('stroke', this.prevStrokeColor);
      this.prevStrokeColor = null;
    }

    updateConflictedShape(x: number, y: number) {
      if (this.conflictShape) {
        const size = SEATRADIUS * 2.4 * this.app.seatmap.scale;
        this.conflictShape.size(size).center(x, y);
      }
    }
  };
};
